import { Button, Spinner } from "@zapier/design-system";

export default function SpinnerButton() {
  return (
    <Button color="primary" disabled={true}>
      <Spinner />
    </Button>
  );
}
